import { TextField } from "@mui/material";

type Props = {
  value: string;
  onChange: (value: string) => void;
};

const ServiceInstructionsInput = ({ value, onChange }: Props) => {
  return <TextField
    value={value}
    onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange(event.target.value)}
    placeholder="Door code, pets, where to park…"
    multiline
    fullWidth
    maxRows={3}
    style={{ backgroundColor: "white" }}
  />;
}

export default ServiceInstructionsInput;
